<div class="step-component">
  <h2>Wat is het probleem?</h2>
  <div class="step-content-label">Kies het defect:</div>
  <div>
    <ul class="radioList">
      <li class="custom-control custom-radio" *ngFor="let item of defectList">
        <input type="radio" class="custom-control-input" [(ngModel)]="defect" name="list_defect" id="{{item.itemValue}}" value="{{item.itemValue}}" (change)="onItemChange(item)" mdbInput />
        <label class="custom-control-label" for="{{item.itemValue}}">{{item.itemName}}</label>
      </li>
    </ul>
  </div>

</div>
